/**
 * assets/tracking-capture.js
 * Gedrag van snippets/tracking-capture.liquid
 *
 * Geknipt uit de inline <script> van dat bestand op 2026-08-15, 1:1.
 * Data komt uit dat bestand, gedrag staat hier. Zie ARCHITECTURE.md sectie 11.
 */

(function() {
  'use strict';

  const log = (msg, data) => {
    if (window.__DEBUG_TRACKING) {
      console.log(`[VC-Track] ${msg}`, data || '');
    }
  };

  /* Laatst geinjecteerde consent-stand; voorkomt dubbele /cart/update.js calls.*/
  /* Een vingerafdruk over ALLE consent-velden, niet alleen het besluit: anders*/
  /* valt een wijziging in alleen analytics of sale_of_data stil weg.*/
  let lastConsent = null;
  let listenerGeplaatst = false;

  function consentVingerafdruk(d) {
    if (!d) return '';
    return [d.consent, d.consent_marketing, d.consent_analytics,
            d.consent_sale_of_data, d.consent_id].join('|');
  }

  /* --- Utility: Parse GA4 cookies ---*/
  function parseGA4Cookies() {
    const result = {};

    /* _ga: "GA1.1.xxxxxxxxx.xxxxxxxxx" -> client_id = xxxxxxxxx.xxxxxxxxx*/
    const gaCookie = document.cookie.split('; ').find(c => c.startsWith('_ga='));
    if (gaCookie) {
      const parts = gaCookie.split('=')[1].split('.');
      if (parts.length >= 4) {
        result.ga_client_id = parts.slice(2).join('.');
        log('GA4 client_id parsed', result.ga_client_id);
      }
    }

    /* _ga_9HQRM66093: session cookie - twee formaten*/
    /* Oud (GS1): "GS1.1.xxxxxxxxx.x.x.x.x" -> session_id = parts[2]*/
    /* Nieuw (GS2): "GS2.1.sXXXXXXXXXX$oXX$gX$..." -> session_id = na 's' in eerste $-segment*/
    const gsMeasurementCookie = document.cookie
      .split('; ')
      .find(c => c.startsWith('_ga_9HQRM66093='));

    if (gsMeasurementCookie) {
      const cookieValue = gsMeasurementCookie.split('=')[1];

      if (cookieValue.startsWith('GS2.')) {
        /* Nieuw GS2 formaat: "GS2.1.sXXXXXXXXXX$oXX$gX$tXXXXX$jXX$lX$hXXXX"*/
        /* Session ID zit in het eerste $-segment, na de 's' prefix*/
        const afterPrefix = cookieValue.substring(4); /* na "GS2."*/
        const dotParts = afterPrefix.split('.');
        if (dotParts.length >= 2) {
          const sessionPart = dotParts[1]; /* "sXXXXXXXXXX$oXX$..."*/
          const dollarParts = sessionPart.split('$');
          if (dollarParts[0] && dollarParts[0].startsWith('s')) {
            result.ga_session_id = dollarParts[0].substring(1); /* verwijder 's' prefix*/
            log('GA4 session_id parsed (GS2)', result.ga_session_id);
          }
        }
      } else {
        /* Oud GS1 formaat: "GS1.1.xxxxxxxxx.x.x.x.x"*/
        const parts = cookieValue.split('.');
        if (parts.length >= 3) {
          result.ga_session_id = parts[2];
          log('GA4 session_id parsed (GS1)', result.ga_session_id);
        }
      }
    }

    return result;
  }

  /* --- Utility: Get URL parameters ---*/
  function getUrlParams() {
    const params = {};
    const search = new URLSearchParams(window.location.search);

    const paramNames = [
      'gclid', 'wbraid', 'gbraid',
      'ttclid', 'fbclid',
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'
    ];

    paramNames.forEach(name => {
      if (search.has(name)) {
        params[name] = search.get(name);
      }
    });

    if (Object.keys(params).length > 0) {
      log('URL params detected', params);
    }

    return params;
  }

  /* --- Utility: wacht tot de Customer Privacy API beschikbaar is ---*/
  /* Shopify laadt consent-tracking-api niet vanzelf. Zonder deze aanroep leest*/
  /* getConsentStatus() te vroeg en levert 'unknown' op terwijl de bezoeker wel*/
  /* een keuze heeft gemaakt.*/
  function waitForPrivacyApi() {
    return new Promise(resolve => {
      if (window.Shopify && window.Shopify.customerPrivacy) return resolve();
      if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') return resolve();

      let settled = false;
      const finish = () => { if (!settled) { settled = true; resolve(); } };

      try {
        window.Shopify.loadFeatures(
          [{ name: 'consent-tracking-api', version: '0.1' }],
          finish
        );
      } catch (e) {
        log('loadFeatures error', e.message);
        return finish();
      }

      /* Bovengrens: nooit langer blijven hangen dan de cookie-wachttijd*/
      setTimeout(finish, 3000);
    });
  }

  /* --- Toestemming lezen volgens de Customer Privacy API ---*/
  /**/
  /* Twee bronnen met een verschillende betekenis; ze zijn geen alternatief*/
  /* voor elkaar.*/
  /**/
  /*  1. currentVisitorConsent() -> { marketing, analytics, preferences, sale_of_data }*/
  /*     als STRING: 'yes' | 'no' | '' (leeg = nog niet beslist).*/
  /*     Dit is de ruwe keuze van de bezoeker. DIAGNOSE.*/
  /**/
  /*  2. marketingAllowed() / analyticsProcessingAllowed() / saleOfDataAllowed()*/
  /*     als BOOLEAN. Documentatie: "Use the Allowed methods to check what*/
  /*     processing is allowed. They combine several factors missing from the*/
  /*     currentVisitorConsent" - te weten de winkelinstellingen en de regio*/
  /*     van de bezoeker. Dit is het BESLUIT.*/
  /**/
  /* Wij sturen op het besluit en bewaren de ruwe keuze ernaast.*/
  /**/
  /* @param detail  optioneel: event.detail van 'visitorConsentCollected'.*/
  /*                Shopify stuurt daar de booleans in mee. Die winnen, want*/
  /*                ze horen bij het moment van de keuze.*/
  function readConsent(detail) {
    const uit = {
      decision: 'unknown',    /* yes | no | unknown  -> stuurt de upload naar Google*/
      marketing: 'unknown',   /* yes | no | undecided | unknown -> ruwe keuze*/
      analytics: 'unknown',
      saleOfData: 'unknown',
      consentId: null
    };

    const cp = (window.Shopify && window.Shopify.customerPrivacy) || null;

    /* 1. Ruwe keuze. Enige bron waarin 'nog niet beslist' zichtbaar is.*/
    if (cp && typeof cp.currentVisitorConsent === 'function') {
      try {
        const ruw = cp.currentVisitorConsent() || {};
        uit.marketing = ruw.marketing === 'yes' ? 'yes'
                      : ruw.marketing === 'no' ? 'no'
                      : 'undecided';
        log('currentVisitorConsent', ruw);
      } catch (e) {
        log('currentVisitorConsent error', e.message);
      }
    }

    /* 2. Besluit. event.detail eerst, anders de API-methode.*/
    /*    De sleutel in event.detail heet anders dan de methode; vandaar beide.*/
    function toegestaan(detailSleutel, methode) {
      if (detail && typeof detail[detailSleutel] === 'boolean') {
        return detail[detailSleutel];
      }
      if (cp && typeof cp[methode] === 'function') {
        try { return cp[methode](); } catch (e) { log(methode + ' error', e.message); }
      }
      return null;   /* niet vast te stellen*/
    }

    const magMarketing = toegestaan('marketingAllowed', 'marketingAllowed');
    const magAnalytics = toegestaan('analyticsAllowed', 'analyticsProcessingAllowed');
    const magVerkoop   = toegestaan('saleOfDataAllowed', 'saleOfDataAllowed');

    uit.analytics  = magAnalytics === null ? 'unknown' : (magAnalytics ? 'yes' : 'no');
    uit.saleOfData = magVerkoop === null ? 'unknown' : (magVerkoop ? 'yes' : 'no');

    if (uit.marketing === 'no') {
      /* VOORRANGSREGEL: een expliciete weigering wint ALTIJD, ook als*/
      /* marketingAllowed() true zou teruggeven. Die methode weegt ook*/
      /* winkelinstellingen en regio mee, en het is niet gedocumenteerd dat een*/
      /* expliciete opt-out daar in elk regime bovenop gaat. Een 'nee' van de*/
      /* bezoeker als toestemming uploaden is geen meetfout maar een*/
      /* AVG-overtreding; die kant van de asymmetrie nemen we niet.*/
      uit.decision = 'no';
    } else if (magMarketing === true) {
      uit.decision = 'yes';
    } else if (magMarketing === false) {
      /* Verwerking niet toegestaan. Is er ook geen keuze gemaakt, dan is dat*/
      /* 'unknown' en geen weigering - dat onderscheid moeten we kunnen meten.*/
      uit.decision = uit.marketing === 'undecided' ? 'unknown' : 'no';
    } else {
      /* API niet beschikbaar. Terugvallen op de ruwe keuze.*/
      uit.decision = uit.marketing === 'yes' ? 'yes'
                   : uit.marketing === 'no' ? 'no'
                   : 'unknown';
    }

    /* 3. Audit-spoor. Shopify's eigen referentie naar het toestemmingsrecord.*/
    if (cp && typeof cp.consentId === 'function') {
      try { uit.consentId = cp.consentId() || null; } catch (e) { log('consentId error', e.message); }
    }

    log('Consent gelezen', uit);
    return uit;
  }

  /* --- Main tracking function ---*/
  async function captureTracking(consentDetail) {
    log('Initializing tracking capture v2...');

    /* Wacht 1500ms totdat GA4 cookies beschikbaar zijn, en parallel daaraan tot*/
    /* de privacy-API geladen is. Parallel, zodat dit geen extra vertraging geeft.*/
    await Promise.all([
      new Promise(resolve => setTimeout(resolve, 1500)),
      waitForPrivacyApi()
    ]);

    const gaData = parseGA4Cookies();
    const urlParams = getUrlParams();
    const consent = readConsent(consentDetail);

    /* Merge met eerder opgeslagen data (vorige pageview kan gclid bevatten)*/
    let existingData = {};
    try {
      const stored = sessionStorage.getItem('_vc_tracking');
      if (stored) existingData = JSON.parse(stored);
    } catch (e) { /* ignore parse errors */ }

    const trackingData = {
      ...existingData,   /* bewaar eerdere gclid/utm params*/
      ...gaData,          /* update GA4 IDs (altijd vers)*/
      consent: consent.decision,
      consent_marketing: consent.marketing,
      consent_analytics: consent.analytics,
      consent_sale_of_data: consent.saleOfData,
      consent_id: consent.consentId || '',
      ts: Date.now()
    };

    /* URL params overschrijven alleen als ze aanwezig zijn (niet wissen bij volgende pageview)*/
    if (Object.keys(urlParams).length > 0) {
      Object.assign(trackingData, urlParams);
    }

    /* Sla op in sessionStorage*/
    const hasUsefulData = trackingData.ga_client_id || trackingData.gclid ||
                          trackingData.wbraid || trackingData.gbraid;
    if (hasUsefulData) {
      sessionStorage.setItem('_vc_tracking', JSON.stringify(trackingData));
      log('Tracking data saved to sessionStorage', trackingData);
    }

    return trackingData;
  }

  /* --- Cart attribute injection (direct via /cart/update.js) ---*/
  async function injectCartAttributes(trackingData) {
    if (!trackingData) {
      /* Fallback: lees uit sessionStorage*/
      try {
        const stored = sessionStorage.getItem('_vc_tracking');
        if (stored) trackingData = JSON.parse(stored);
      } catch (e) { return; }
    }
    if (!trackingData) return;

    const attributes = {};
    const attrNames = [
      'gclid', 'wbraid', 'gbraid',
      'ttclid', 'fbclid',
      'utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term',
      'ga_client_id', 'ga_session_id'
    ];

    attrNames.forEach(name => {
      if (trackingData[name]) {
        attributes['_' + name] = trackingData[name];
      }
    });

    /* Het BESLUIT. Altijd injecteren, ook 'unknown'; server-side telt*/
    /* 'unknown' als 'denied' en dat moet zo blijven - alleen een expliciet*/
    /* 'yes' mag naar Google als toestemming.*/
    attributes['_consent'] = trackingData.consent || 'unknown';

    /* Diagnose ernaast. Hiermee is een LEESFOUT ('unknown' terwijl de bezoeker*/
    /* wel koos) te scheiden van een echte weigering, zonder het besluit zelf*/
    /* te vertroebelen. Dat onderscheid ontbrak op 13-08 en kostte meetdagen.*/
    if (trackingData.consent_marketing) attributes['_consent_marketing'] = trackingData.consent_marketing;
    if (trackingData.consent_analytics) attributes['_consent_analytics'] = trackingData.consent_analytics;
    if (trackingData.consent_sale_of_data) attributes['_consent_sale_of_data'] = trackingData.consent_sale_of_data;
    if (trackingData.consent_id) attributes['_consent_id'] = trackingData.consent_id;

    if (Object.keys(attributes).length === 0) return;

    try {
      log('Injecting cart attributes', attributes);
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ attributes: attributes })
      });

      if (response.ok) {
        lastConsent = consentVingerafdruk(trackingData);
        log('Cart attributes injected successfully', Object.keys(attributes));
      } else {
        log('Cart injection HTTP error', response.status);
      }
    } catch (err) {
      log('Cart injection error', err.message);
    }
  }

  /* --- Consent change handler ---*/
  async function onConsentChange(event) {
    const detail = (event && event.detail) || null;
    log('Consent changed', detail || event);
    /* detail doorgeven: Shopify stuurt de booleans mee op het moment van de*/
    /* keuze. Zelf herlezen kan net te vroeg zijn.*/
    const data = await captureTracking(detail);
    if (consentVingerafdruk(data) === lastConsent) {
      log('Consent ongewijzigd, geen her-injectie', data.consent);
      return;
    }
    await injectCartAttributes(data);
  }

  /* --- Consent change listener ---*/
  function setupConsentListener() {
    /* 'visitorConsentCollected' op document is het ENIGE gedocumenteerde*/
    /* browser-event van de Customer Privacy API. Het vuurt zodra de bezoeker*/
    /* de banner beantwoordt en ook wanneer hij zijn keuze later aanpast, ook*/
    /* als Shopify.customerPrivacy op dat moment nog niet bestaat.*/
    /**/
    /* Hier stond eerder ook customerPrivacy.addEventListener(*/
    /* 'consent_status_changed', ...). Dat event bestaat niet en*/
    /* addEventListener staat niet op dat object: dode code die de indruk wekte*/
    /* dat latere wijzigingen werden opgevangen. Verwijderd op 15-08-2026.*/
    if (listenerGeplaatst) return;
    document.addEventListener('visitorConsentCollected', onConsentChange);
    listenerGeplaatst = true;
  }

  /* --- Initialize ---*/
  async function init() {
    /* Stap 1: luister DIRECT, voor de 1500ms wachttijd. Beantwoordt de bezoeker*/
    /* de banner binnen dat venster, dan missen we hem anders.*/
    setupConsentListener();

    /* Stap 2: capture tracking data (wacht op GA4 cookies + privacy-API)*/
    const trackingData = await captureTracking();

    /* Stap 3: inject in cart (pas NA captureTracking klaar is)*/
    await injectCartAttributes(trackingData);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
